import { render, staticRenderFns } from "./DxTableHistorialVenta.vue?vue&type=template&id=71173f9c&scoped=true&"
import script from "./DxTableHistorialVenta.vue?vue&type=script&lang=ts&"
export * from "./DxTableHistorialVenta.vue?vue&type=script&lang=ts&"
import style0 from "./DxTableHistorialVenta.vue?vue&type=style&index=0&id=71173f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71173f9c",
  null
  
)

export default component.exports